import { DevicesOther } from "@mui/icons-material";
import ArrowRight from "@src/icons/ArrowRight";
import styled from "styled-components";

export const DetailLinkIcon = styled(DevicesOther)`
    && {
        width: 15px;
        height: 15px;
        margin-right: 5px;
    }
`;

export const ChangeDeviceButtonIcon = styled(ArrowRight)`
    && {
        width: 12px;
        height: 12px;
        margin-right: 5px;
    }
`;
